export default __webpack_public_path__ + "static/media/Panorama.be539445.avif";